import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=c99dd4ca&scoped=true&lang=html"
import script from "./Buy.vue?vue&type=script&lang=js"
export * from "./Buy.vue?vue&type=script&lang=js"
import style0 from "./Buy.vue?vue&type=style&index=0&id=c99dd4ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99dd4ca",
  null
  
)

export default component.exports